export default async function ({ store, route, redirect }) {
  if (!route.name) {
    if (store.$auth.loggedIn) {
      redirect('/404');
    }
    redirect('/not-found');
  }
}
